/**
 * Shopify integration visibility gate (VP-223).
 *
 * The production integration has limited visibility: only designated testers
 * can see and test it. Access is granted through this email allowlist, never by
 * changing a user's database role (CLAUDE.md section 0 forbids granting
 * `super_admin`).
 *
 * This is the shared source of truth for the backend `requireShopifyAccess`
 * middleware and the frontend integrations views.
 */

/**
 * Testers allowed to access Shopify in addition to the `super_admin` role.
 * `meta-reviewer@` is the demo account supplied to App Store reviewers; without
 * it, a reviewer cannot see the integration they have just installed (VP-255).
 */
export const SHOPIFY_TESTER_EMAILS: ReadonlySet<string> = new Set<string>([
  "adrian.gasek.99@gmail.com",
  "adrian.gasek.99+shopify@gmail.com",
  "meta-reviewer@gawronify.com",
]);

export type ShopifyAccessUser = {
  role?: string | null;
  email?: string | null;
};

/** Shopify access requires `super_admin` or a case-insensitive allowlist match. */
export function canAccessShopifyIntegration(user: ShopifyAccessUser | null | undefined): boolean {
  if (!user) return false;
  if (user.role === "super_admin") return true;
  const email = (user.email ?? "").toLowerCase();
  return email.length > 0 && SHOPIFY_TESTER_EMAILS.has(email);
}
